<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  modalTitle="{{ model ? 'Editar' : 'Nova' }} nota"
  width="25rem"
  height="auto"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <div class="fields-container">
        <div class="field-set">
          <label label>Nota*</label>

          <app-input-box
            formControlName="text"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="Salvar"
          [disabled]="formGroup.invalid"
          width="100%"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Cancelar"
          (click)="onBtnCancelClick()"
          width="100%"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
